<template>
  <div class="mod">
    <div v-on-clickaway="togglePlaceholderOn">
      <input @input="setSearchQuery($event.target.value)" :value="searchQuery" ref="input" :placeholder="placeholder" @keyup.enter="submit" @keyup.esc="togglePlaceholder" @focus="togglePlaceholder" @blur="togglePlaceholder" :class="placeholderOn ? '' : 'expanded'">
      <button class="button" ref="button" @click="submit"><img src="./Search.svg" width="20" height="20"></button>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'search',
  data () {
    return {
      placeholderOn: true
    }
  },
  mixins: [ clickaway ],
  mounted () {
    let q = this.$route.query.q
    if (q) {
      this.setSearchQuery(q)
    }
  },
  methods: {
    submit () {
      let vm = this
      vm.$router.push({name: 'Search', query: {q: vm.searchQuery}})
    },
    togglePlaceholder () {
      if (this.placeholderOn) {
        this.placeholderOn = false
      } else if (!this.searchQuery) {
        this.placeholderOn = true
      }
    },
    togglePlaceholderOn () {
      this.placeholderOn = true
    },
    ...mapActions([
      'setSearchQuery'
    ])
  },
  computed: {
    placeholder () {
      return this.placeholderOn ? 'Search' : ''
    },
    ...mapGetters([
      'searchQuery'
    ])
  },
  watch: {
    placeholderOn () {
      this.$parent.searching = !this.placeholderOn
    }
  }
}
</script>

<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .mod
    +until($tablet)
      margin-top: 20px
    > div
      display: flex
      text-align: left
      line-height: 1.1
      position: relative
      border-bottom: 1px solid
      input
        width: 100%
        border: none
        padding-top: 7px
        padding-bottom: 3px
        padding-right: 20px
        font-size: 13px
        transition: width 150ms
        height: 36px
        +tablet
          width: 75px
          padding-top: 3px
          padding-bottom: 10px
        &.expanded
          +tablet
            width: 150px
        &::placeholder
          color: $textColor
      .button
        border: 0
        padding: 0
        height: 36px
        position: absolute
        right: 0
</style>



// WEBPACK FOOTER //
// SearchModule.vue?5ae1f759